import { ExportedStatements } from './ExportedStatements';

export const Exports = () => {
  return <ExportedStatements />;
};
